export default function () {
      return {
        typeList:[],
      }
    }